import { eventTypeColors } from 'screens/Orders/utils';
import ScheduledItemBorder from './ScheduledItemBorder';
import { CalendarEvent } from 'api/orders/schemas';
import { formatCarrier } from 'screens/SelectServices/utils';

const ScheduledItem = ({ event }: { event: CalendarEvent }) => {
  return (
    <div className="flex items-center gap-2 self-stretch p-2">
      <ScheduledItemBorder color={eventTypeColors['install']} />
      <div className="flex flex-col items-start gap-1">
        <p className="overflow-hidden text-ellipsis text-sm font-bold text-content-base-default">
          {event.product_name} install with{' '}
          {formatCarrier(event.vendor as string)}
        </p>
        <p className="overflow-hidden text-ellipsis text-xs font-semibold text-content-base-subdued">
          <span>{event.address}</span>
        </p>
        <p className="overflow-hidden text-ellipsis text-xs font-semibold text-content-base-subdued">
          <span>{event.site_name}</span>
        </p>
      </div>
    </div>
  );
};

export default ScheduledItem;
